import OPNV from "./opnv";
import PKW from "./pkw";
import Taxi from "./taxi";

export default class Fahrtkosten {
    constructor(
        pkw = {
            active: false,
            calculated: true,
            begruendung: '',
            kilometer: 0,
            summe: 0,
            kennzeichen: ''
        },
        opnv = {
            active: false,
            summe: 0,
            belege: []
        },
        taxi = {
            active: false,
            summe: 0,
            belege: []
        }
    ) {
        this.pkw = new PKW(
            pkw?.active,
            pkw?.calculated,
            pkw?.begruendung,
            pkw?.kilometer,
            pkw?.summe,
            pkw?.kennzeichen
        );
        this.opnv = new OPNV(
            opnv?.active,
            opnv?.summe,
            opnv?.belege
        );
        this.taxi = new Taxi(
            taxi?.active,
            taxi?.summe,
            taxi?.belege
        );
        this.summe = this.calculateSumme();
    }

    calculateSumme() {
        return this.pkw.summe + this.opnv.summe + this.taxi.summe;
    }

    toFirestore() {
        return {
            pkw: this.pkw.toFirestore(),
            opnv: this.opnv.toFirestore(),
            taxi: this.taxi.toFirestore()
        };
    }
}